import { render, staticRenderFns } from "./Step-2.vue?vue&type=template&id=446d85b0&scoped=true&"
import script from "./Step-2.vue?vue&type=script&lang=js&"
export * from "./Step-2.vue?vue&type=script&lang=js&"
import style0 from "./Step-2.vue?vue&type=style&index=0&id=446d85b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d85b0",
  null
  
)

export default component.exports